import { useEffect, useState } from 'react';
import { Dictionary } from '../types/Dictionary';
import useLocale from './useLocale';
import { SweetAlertOptions } from 'sweetalert2';
import useSwal from './useSwal';
import { MasterDataLocalizationType } from "../types/master-data/MasterDataLocalizationType";


function useTranslation(componentName: string) {
    const localeCtx = useLocale();
    const swal = useSwal();
    const [translationsLoading, setTranslationsLoading] =
        useState<boolean>(false);
    const [translations, setTranslations] = useState<
        Dictionary<string> | undefined>(localeCtx?.selectedLocale?.current.componentTranslations[componentName]);
  useEffect(() => {
        setTranslations(localeCtx?.selectedLocale?.current.componentTranslations[componentName]);
    }, [localeCtx?.selectedLocale?.current.componentTranslations[componentName]])
    const fetchLabelKeyTranslation = (
        key: string,
        defaultValue: string
    ): string => {
        if (translations) {
            const lowerKey = key?.toLowerCase().trim();
            for (const k in translations) {
                if (translations.hasOwnProperty(k) && k?.toLowerCase().trim() === lowerKey) {
                    return translations[k];
                }
            }
        }
        return defaultValue;
    };

    const fetchTranslations = async (component: string) => {
        try {
            setTranslationsLoading(true);
            const resp = await localeCtx?.setComponentTranslations(component);
            setTranslations(resp);
        } catch (err) {
            console.error(err);
            setTranslations(
                localeCtx?.selectedLocale?.previous.componentTranslations[component]
            );
            localeCtx?.setPreviousAppLocale(component);
            if (localeCtx?.localeSwitchFailed) {
                const swalOptions: SweetAlertOptions<any, any> = {
                    icon: "error",
                    title: "Error",
                    text: "Couldn't Switch Language",
                };
                swal.fire(swalOptions);
            }
        } finally {
            setTimeout(() => {
                setTranslationsLoading(false);
            }, 100);
        }
    };
    const fetchGroupTranslations = async (translateDataKeys: string[], source: string)=> {
        try {
            const resp = await localeCtx?.setMasterDataTranslation(translateDataKeys,source);
            const dataTranslation: MasterDataLocalizationType = {
            localeCode: localeCtx?.selectedLocale?.current.locale.code ?? "",
            data: resp
            };
            return(dataTranslation);
        } catch (err) {
            console.error(err);
            const dataTranslation: MasterDataLocalizationType = {
            localeCode: localeCtx?.selectedLocale?.previous.locale.code ?? "",
            data: localeCtx?.selectedLocale?.previous.masterDataTranslations,
            };
            return(dataTranslation);
        } finally {
        }
  };
    return { fetchLabelKeyTranslation, translations, translationsLoading, fetchTranslations, setTranslations, fetchGroupTranslations };
}

export default useTranslation;